import { motion } from "framer-motion";
import { Wrench, Hammer, Paintbrush, Trees, Home, Sofa } from "lucide-react";
import { IMAGES } from "@/data/images";

const CATS = [
  { icon: Hammer, title: "Assembly & Mounting", desc: "Flat-pack, TVs, shelves, mirrors & more." },
  { icon: Home, title: "Doors & Windows", desc: "Handles, locks, hanging & draught proofing." },
  { icon: Paintbrush, title: "Painting & Decorating", desc: "Walls, ceilings, skirting & wallpaper." },
  { icon: Trees, title: "Outdoor & Garden", desc: "Fences, gutters, decking & pressure washing." },
  { icon: Sofa, title: "Bathroom & Kitchen", desc: "Grouting, splashbacks & accessory fitting." },
  { icon: Wrench, title: "General Repairs", desc: "The odd jobs, fixes & maintenance." },
];

const fade = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06 } }),
};

export const Services = ({ onQuote }) => {
  return (
    <section id="services" className="bg-[#F3F4F6] border-y-2 border-[#0A1A4A] py-20 sm:py-28">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ What We Do</div>
          <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95]">
            ALL HANDYMAN JOBS.<br />ONE LOCAL TEAM.
          </h2>
        </div>

        {/* Bento */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Tall image */}
          <motion.div
            variants={fade} custom={0} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="lg:row-span-2 relative border-2 border-[#0A1A4A] overflow-hidden shadow-hard min-h-[320px]"
            data-testid="service-feature-image"
          >
            <img src={IMAGES.drillWall} alt="Handyman drilling" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1A4A] via-[#0A1A4A]/20 to-transparent" />
            <div className="absolute bottom-0 left-0 p-8">
              <div className="font-mono-accent text-[10px] tracking-widest uppercase text-[#EAB308] mb-2">Fully Equipped</div>
              <div className="font-display font-black text-white text-3xl uppercase leading-tight">Right Tools.<br />Right Job.</div>
            </div>
          </motion.div>

          {CATS.map((c, i) => (
            <motion.button
              key={c.title}
              onClick={onQuote}
              variants={fade} custom={i + 1} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="group text-left bg-white border-2 border-[#0A1A4A] p-7 hover:bg-[#2563EB] transition-colors"
              data-testid={`service-card-${i}`}
            >
              <c.icon className="text-[#2563EB] group-hover:text-white transition-colors mb-5" size={34} strokeWidth={2} />
              <h3 className="font-display font-extrabold uppercase text-lg text-[#0A1A4A] group-hover:text-white transition-colors">{c.title}</h3>
              <p className="text-sm text-[#0A1A4A]/70 group-hover:text-white/80 transition-colors mt-2">{c.desc}</p>
              <div className="mt-5 font-mono-accent text-xs tracking-widest uppercase text-[#0A1A4A]/50 group-hover:text-white/70 transition-colors">
                £60 minimum charge
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
